module.exports = __webpack_public_path__ + "static/media/Slice8.73d3eed0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_151/img/Slice8.png
// module id = 1489
// module chunks = 0